import definition from './roles.service';

/**
 * RolesApi settings
 * @type {{name: string, definition: RolesApi}}
 */
export default {
    name: 'RolesApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/roles/index.js